__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "shell";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@angular/animations", "18.2.8", () => (() => (__webpack_require__(7172))), 1);
			register("@angular/cdk/observers", "18.2.14", () => (() => (__webpack_require__(9539))), 1);
			register("@angular/cdk/table", "18.2.14", () => (() => (__webpack_require__(8657))), 1);
			register("@angular/common/http", "18.2.8", () => (() => (__webpack_require__(6443))), 1);
			register("@angular/common", "18.2.8", () => (() => (__webpack_require__(316))), 1);
			register("@angular/core", "18.2.8", () => (() => (__webpack_require__(7404))), 1);
			register("@angular/forms", "18.2.8", () => (() => (__webpack_require__(4456))), 1);
			register("@angular/router", "18.2.8", () => (() => (__webpack_require__(5072))), 1);
			register("@ng-bootstrap/ng-bootstrap", "17.0.1", () => (() => (__webpack_require__(4513))), 1);
			register("@popperjs/core", "2.11.8", () => (() => (__webpack_require__(2864))), 1);
			register("@swimlane/ngx-charts", "20.5.0", () => (() => (__webpack_require__(298))), 1);
			register("@tinymce/tinymce-angular", "8.0.1", () => (() => (__webpack_require__(297))), 1);
			register("angular-svg-icon", "17.0.0", () => (() => (__webpack_require__(3313))), 1);
			register("apollo-angular", "7.2.1", () => (() => (__webpack_require__(8807))), 1);
			register("core", "8.8.0", () => (() => (__webpack_require__(1575))), 1);
			register("graphql", "16.14.2", () => (() => (__webpack_require__(6823))), 1);
			register("lodash-es", "4.18.1", () => (() => (__webpack_require__(5786))), 1);
			register("luxon", "3.5.0", () => (() => (__webpack_require__(4735))), 1);
			register("mathjs", "13.2.3", () => (() => (__webpack_require__(7875))), 1);
			register("ng-animate", "2.0.1", () => (() => (__webpack_require__(371))), 1);
			register("ngx-chips", "3.0.0", () => (() => (__webpack_require__(2622))), 1);
			register("rxjs/operators", "7.8.2", () => (() => (__webpack_require__(3620))), 1);
			register("rxjs", "7.8.2", () => (() => (__webpack_require__(1340))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};